import { axiosClient } from "../axiosClient"

export const fetchUsers = async (param: string, search) => {
    const { data } = await axiosClient.get('/admin/users', { params: { cursor: param, search } })
    console.log(data, 'admin users')
    return data
}

export const removeUser = async (userId) => {
    const { data } = await axiosClient.post("/admin/user/remove", { userId })
    console.log(data)
    return data
}


export const suspendUser = async (userId) => {
    const { data } = await axiosClient.post("/admin/user/suspend", { userId })
    console.log(data)
    return data
}

export const toggleSellerVerified = async (userId: string) => {
    const { data } = await axiosClient.post("/admin/user/toggle-seller-verified", { userId })
    return data
}

// ==================== SELLER SUSPENSION ====================

export type SuspensionReason =
    | 'fraudulent_listings'
    | 'policy_violations'
    | 'spam'
    | 'scam'
    | 'counterfeit_goods'
    | 'harassment'
    | 'multiple_reports'
    | 'other';

export interface ToggleSellerSuspensionData {
    userId: string;
    reason?: SuspensionReason;
    reasonDetails?: string;
    expiresAt?: string; // ISO date string
}

export interface CreateSellerSuspensionData {
    userId: string;
    reason: SuspensionReason;
    reasonDetails?: string;
    expiresAt?: string;
    adminNotes?: string;
    relatedReportId?: string;
}

export interface ReviewAppealData {
    approved: boolean;
    appealResponse: string;
}

// Toggle seller suspension (suspend/restore)
export const toggleSellerSuspension = async (data: ToggleSellerSuspensionData) => {
    const response = await axiosClient.post("/admin/user/toggle-seller-suspension", data)
    return response.data
}

// Create a seller suspension with full details
export const createSellerSuspension = async (data: CreateSellerSuspensionData) => {
    const response = await axiosClient.post("/admin/seller-suspension/create", data)
    return response.data
}

// Remove a seller suspension (restore access)
export const removeSellerSuspension = async (userId: string) => {
    const response = await axiosClient.post("/admin/seller-suspension/remove", { userId })
    return response.data
}

// Get all suspended sellers (paginated)
export const getSuspendedSellers = async (params?: {
    cursor?: string;
    limit?: number;
    appealStatus?: string;
}) => {
    const { data } = await axiosClient.get("/admin/seller-suspensions", { params })
    return data
}

// Get seller suspension statistics
export const getSuspensionStats = async () => {
    const { data } = await axiosClient.get("/admin/seller-suspensions/stats")
    return data
}

// Review an appeal (approve or reject)
export const reviewSellerAppeal = async (suspensionId: string, data: ReviewAppealData) => {
    const response = await axiosClient.post(`/admin/seller-suspension/${suspensionId}/review-appeal`, data)
    return response.data
}

// Get suspension status for a specific user
export const getUserSellerSuspension = async (userId: string) => {
    const { data } = await axiosClient.get(`/admin/user/${userId}/seller-suspension`)
    return data
}
